import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftMenu = _resolveComponent("LeftMenu")!
  const _component_PageWithLeftMenu = _resolveComponent("PageWithLeftMenu")!

  return (_openBlock(), _createBlock(_component_PageWithLeftMenu, null, {
    left_menu: _withCtx(() => [
      _createVNode(_component_LeftMenu)
    ]),
    _: 1
  }))
}